import { styled } from "@mui/system";
export const VaTitle = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    fontSize: 16,
    fontWeight: 600,
    marginTop: 6,
}));
export const VaContent = styled("div")(({}) => ({
    color: " #8E95AA",
    fontSize: 13,
    textAlign: "center",
}));
export const VaButtonNo = styled("div")(({}) => ({
    marginRight: 12,
}));
export const ButtonWrapper = styled("div")(({}) => ({
    display: "flex",
    marginTop: 20,
    alignItems: "center",
    justifyContent: "center",
}));
export const LogoCss = styled("div")(() => ({
    textAlign: "center",
    marginTop: " 30px",
}));
export const LogoWrapper = styled("div")(({}) => ({
    display: "flex",
    marginTop: 20,
    justifyContent: "center",
}));
